import { getDHM } from "@/utils/dhmCalculation";
import React, { useState, useEffect, memo } from "react";

const UpcomingAuctionCountDown = ({ until }) => {
  const currentDate = new Date();
  const futureDate = new Date();
  futureDate.setDate(
    currentDate.getDate() + parseInt(until / (60 * 60 * 24), 10)
  );
  futureDate.setHours(
    currentDate.getHours() + (parseInt(until / (60 * 60), 10) % 24)
  );
  futureDate.setMinutes(
    currentDate.getMinutes() + (parseInt(until / 60, 10) % 60)
  );
  futureDate.setSeconds(currentDate.getSeconds() + (until % 60));
  const [getCurrentTime, setCurrentTime] = useState(getDHM(futureDate));

  useEffect(() => {
    const intervalId = setInterval(() => {
      setCurrentTime(getDHM(futureDate));
    }, 60000);
    return () => clearInterval(intervalId);
  }, [until]);

  return (
    <div className="mt5 mb15 d-flex upcoming-flex">
      <div className="cols mr10">
        <p className="upcoming-digits bold text-center mb0">
          {getCurrentTime?.days || 0}{" "}
        </p>
        <span className="upcoming-days bold text-center mb0">Days</span>
      </div>
      <span className=" mb0 upcoming-counter-dots">:</span>
      <div className="cols ml10 mr10">
        <p className="upcoming-digits bold text-center mb0">
           {(getCurrentTime?.hours ?? 0).toString().padStart(2, '0')}
        </p>
        <span className="upcoming-days bold text-center mb0">Hrs</span>
      </div>
      <span className=" bold text-center mb0 upcoming-counter-dots">:</span>
      <div className="cols ml10">
        <p className="upcoming-digits bold text-center mb0">
          {(getCurrentTime?.minutes ?? 0).toString().padStart(2, '0')}
        </p>
        <span className="upcoming-days bold text-center mb0">Mins</span>
      </div>
      <span className="text-center mb0 upcoming-counter-dots">:</span>
      <div className="cols ml10">
        <p className="upcoming-digits bold text-center mb0">
          {(getCurrentTime?.seconds ?? 0).toString().padStart(2, '0')}
        </p>
        <span className="upcoming-days bold text-center mb0">Secs</span>
      </div>
    </div>
  );
};

export default memo(UpcomingAuctionCountDown);
